import { render } from "./GTIWomensHealthTests.vue?vue&type=template&id=2bffa064"
import script from "./GTIWomensHealthTests.vue?vue&type=script&lang=js"
export * from "./GTIWomensHealthTests.vue?vue&type=script&lang=js"

import "./GTIWomensHealthTests.vue?vue&type=style&index=0&id=2bffa064&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/GTIWomensHealthTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bffa064"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bffa064', __exports__)) {
    console.log('reload')
    api.reload('2bffa064', __exports__)
  }
  
  module.hot.accept("./GTIWomensHealthTests.vue?vue&type=template&id=2bffa064", () => {
    console.log('re-render')
    api.rerender('2bffa064', render)
  })

}


export default __exports__